export const ServerError = "Internal Server Error!";
